import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataIconStringPipe } from './data-icon-string.pipe';

@NgModule({
  declarations: [DataIconStringPipe],
  imports: [CommonModule],
  exports: [DataIconStringPipe]
})
export class DataIconStringModule {}
